@if (messages$ | async; as messages) {
  <div class="messages">
    @for (errorMsg of messages[messageType.MSG_TYPE_ERROR]; track errorMsg; let i = $index) {
      <div class="message message-ERROR">
        <div class="container">
          <i class="aimo-icon icon-inline icon-ERROR mr-2"></i>
          <div class="d-inline" [innerHTML]="errorMsg | cxTranslate | safeHtml"></div>
          <i
            class="aimo-icon icon-inline icon-x icon-sm ml-auto icon-petrol-blue icon-cursor"
            aria-label="{{ 'common.close' | cxTranslate }}"
          (click)="clear(messageType.MSG_TYPE_ERROR, i)"></i>
        </div>
      </div>
    }
    @for (confMsg of messages[messageType.MSG_TYPE_CONFIRMATION]; track confMsg; let i = $index) {
      <div class="alert alert-success">
        <div class="container">
          <div class="left-side inline-block">
            <i class="aimo-icon icon-inline icon-check-circle mr-2"></i>
            <span [innerHTML]="confMsg | cxTranslate | safeHtml"></span>
          </div>
          <i
            class="aimo-icon icon-inline icon-x icon-sm ml-auto icon-petrol-blue icon-cursor"
            aria-label="{{ 'common.close' | cxTranslate }}"
          (click)="clear(messageType.MSG_TYPE_CONFIRMATION, i)"></i>
        </div>
      </div>
    }
    @for (infoMsg of messages[messageType.MSG_TYPE_INFO]; track infoMsg; let i = $index) {
      <div class="message message-INFO">
        <div class="container">
          <i class="aimo-icon icon-inline icon-INFO mr-2"></i>
          <div class="d-inline" [innerHTML]="infoMsg | cxTranslate | safeHtml"></div>
          <i
            class="aimo-icon icon-inline icon-x icon-sm ml-auto icon-petrol-blue icon-cursor"
            aria-label="{{ 'common.close' | cxTranslate }}"
          (click)="clear(messageType.MSG_TYPE_INFO, i)"></i>
        </div>
      </div>
    }
    @for (infoMsg of messages[messageType.MSG_TYPE_WARNING]; track infoMsg; let i = $index) {
      <div class="message message-WARNING">
        <div class="container">
          <i class="aimo-icon icon-inline icon-WARNING mr-2"></i>
          <div class="d-inline" [innerHTML]="infoMsg | cxTranslate | safeHtml"></div>
          <i
            class="aimo-icon icon-inline icon-x icon-sm ml-auto icon-petrol-blue icon-cursor"
            aria-label="{{ 'common.close' | cxTranslate }}"
          (click)="clear(messageType.MSG_TYPE_WARNING, i)"></i>
        </div>
      </div>
    }
    @if (closingTimeMessage$ | async; as closingTime) {
      <div class="message message-WARNING">
        <div class="container">
          <i class="aimo-icon icon-inline icon-WARNING mr-2"></i>
          <div class="d-inline" [innerHTML]="closingTime.message | cxTranslate | safeHtml"></div>
        </div>
      </div>
    }
  </div>
}
